/* =========================================================================
   REKIX product page -- port of source/js/product.js.

   Ported faithfully: gallery/thumbs/swatches, detail tabs, size selection, the
   three-pane size finder and its recommendation maths, and the sticky buy bar.

   Rewritten because the source had no cart:
     - order() used to write "EU 42 reserved for you, send us the order" and
       link to the contact page. That copy is gone; it would now be false.
     - Selecting a size resolves a real VARIANT ID rather than an array index.
     - Add to cart POSTs /cart/add.js and hands the response to Dawn's cart
       drawer, which re-renders and opens itself.

   The recommendation is deliberately not a plain cm lookup. It is:
       foot length -> size cut for that length -> shift by how this pair runs
       -> fall back to the nearest size actually in stock
   Dropping any step gives confidently wrong advice, which is worse than none.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.getElementById('pdp');
  var dataEl = document.getElementById('rekixProductData');
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var chart = DATA.chart || [];
  var variants = DATA.variants || [];
  var sizePos = DATA.sizePos || 0;         // 1-based option position, 0 = no size option
  var UNIT = DATA.sizeUnit || 'EU';
  var selectedSize = null;
  var suggested = null;

  /* ------------------------------------------------------------ helpers */
  function money(cents) {
    // Match Liquid's `money` filter exactly. Hardcoding min:0 produced "$32,500" from JS beside
    // "$38,000.00" from Liquid on the same row -- the decimals come from the shop's money_format.
    var f = DATA.moneyFormat || '';
    var d = DATA.moneyDecimals;
    if (d !== 0 && d !== 2) d = 2;
    var n = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
    return f ? f.replace(/\{\{\s*amount[^}]*\}\}/, n) : n;
  }

  function sizeOf(v) {
    if (!sizePos) return null;
    return v.options[sizePos - 1];
  }

  // Non-size options currently chosen (colour, etc.) so a size click stays on the same colourway.
  function otherSelections() {
    var out = {};
    $$('.swatch.is-active').forEach(function (b) {
      out[b.dataset.optionName] = b.dataset.optionValue;
    });
    return out;
  }

  function findVariant(size) {
    var others = otherSelections();
    var names = [];
    $$('.swatch').forEach(function (b) {
      if (names.indexOf(b.dataset.optionName) === -1) names.push(b.dataset.optionName);
    });
    return variants.filter(function (v) {
      if (size != null && sizeOf(v) !== size) return false;
      // every non-size option must match what is selected
      for (var i = 0; i < v.options.length; i++) {
        if (sizePos && i === sizePos - 1) continue;
        var name = names[0];
        if (name && others[name] && v.options[i] !== others[name]) {
          // only compare the option we actually track
          if (v.options.indexOf(others[name]) === -1) return false;
        }
      }
      return true;
    })[0];
  }

  function stockFor(size) {
    var v = findVariant(size);
    return !!(v && v.available);
  }

  function setVariant(v) {
    var input = $('#rekixVariantId');
    if (input && v) input.value = v.id;
    var price = $('#pPrice');
    if (price && v) price.textContent = money(v.price);
    var sbPrice = $('#sbPrice');
    if (sbPrice && v) sbPrice.textContent = money(v.price);
  }

  function msg(text, kind) {
    var el = $('#buyMsg');
    if (!el) return;
    el.innerHTML = text || '';
    el.className = 'buy__msg' + (kind ? ' is-' + kind : '');
  }

  /* ----------------------------------------------------------- gallery */
  (function gallery() {
    // images AND the product video, in media order -- one slide per thumbnail
    var slides = $$('.pgal__slides > img, .pgal__slides > video');
    var thumbs = $$('.pthumb');
    var gal = $('.pgal');
    function show(i) {
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        if (s.tagName === 'VIDEO') {
          if (n === i) { var p = s.play(); if (p && p.catch) p.catch(function () {}); }
          else s.pause();
        }
      });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      // Drives the badge fade -- see the .pgal.is-detail block in rekix-shopify.css. Set here rather
      // than expressed as a CSS :has() rule so it does not depend on :has() support.
      if (gal) gal.classList.toggle('is-detail', i !== 0);
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      // hovering a thumb previews it -- but not the video: it would start playing as the pointer
      // merely crosses the strip. The video starts on click/tap.
      t.addEventListener('mouseenter', function () { if (!t.classList.contains('pthumb--video')) show(i); });
    });
  })();

  /* ---------------------------------------------------------- swatches */
  $$('.swatch').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.swatch').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      var label = $('#colourName');
      if (label) label.textContent = b.dataset.optionValue;
      // re-resolve the variant for the size already chosen, if any
      var v = findVariant(selectedSize);
      if (v) setVariant(v);
      paintSizeAvailability();
    });
  });

  /* -------------------------------------------------------------- tabs */
  $$('.ptab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var name = tab.dataset.pane;
      $$('.ptab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      $$('.ppane').forEach(function (pane) { pane.classList.toggle('is-active', pane.dataset.pane === name); });
    });
  });

  /* ------------------------------------------------------------- sizes
     One pair, one size: the size is rendered as a fixed chip, not a picker, so there is
     nothing to select and nothing to repaint. Read it once so addToCart has a size to
     report and the variant stays pinned to it. */
  function paintSizeAvailability() {}

  (function lockSize() {
    var chip = $('.size--fixed');
    if (!chip) return;
    selectedSize = chip.dataset.size || null;
    if (!selectedSize) return;
    var v = findVariant(selectedSize);
    if (v) setVariant(v);
  })();

  /* ------------------------------------------------------- size finder
     Ported from source/js/product.js. The maths is unchanged:
         foot length -> size cut for that length -> shift by how this pair runs
     Dropping the fit shift would give confidently wrong advice, which is worse
     than none.

     ADAPTED for one-pair-one-size. The source could offer "Select EU 42" because
     a listing held its whole size run; here the pair is one size, so a match is
     confirmed and a miss sends the shopper to the shop filtered by the size we
     worked out for them -- which is why the Size filter is load-bearing. */
  var chartBody = $('#chartBody');

  function indexForFoot(cm) {
    for (var i = 0; i < chart.length; i++) if (Number(chart[i].cm) >= cm - 0.05) return i;
    return -1;
  }

  function applyFit(i) {
    // fit: 1 = runs large (size down), -1 = runs small (size up), 0 = true to size
    var shift = DATA.fit === 1 ? -1 : DATA.fit === -1 ? 1 : 0;
    return Math.max(0, Math.min(chart.length - 1, i + shift));
  }

  function shopUrlForSize(eu) {
    // The facet is keyed on the OPTION NAME ("size"), not the unit label ("EU") --
    // verified against a live filter URL: ?filter.v.option.size=32
    var base = (window.REKIX && window.REKIX.routes && window.REKIX.routes.allProducts) || '/collections/all';
    var key = String(DATA.sizeOption || 'Size').toLowerCase();
    return base + '?filter.v.option.' + encodeURIComponent(key) + '=' + encodeURIComponent(eu);
  }

  function recommend(baseIndex, hostSel) {
    var host = $(hostSel);
    if (!host) return;

    if (baseIndex < 0 || !chart.length) {
      host.className = 'result is-warn';
      host.innerHTML = '<p class="result__head">That is outside our range</p>' +
        '<p class="result__sub">This chart runs ' + UNIT + ' ' + (chart[0] ? chart[0].eu : '-') +
        ' to ' + UNIT + ' ' + (chart.length ? chart[chart.length - 1].eu : '-') +
        '. Message us and we will look out for your size.</p>';
      return;
    }

    var fitted = applyFit(baseIndex);
    var s = chart[fitted];
    var isThisPair = String(s.eu) === String(selectedSize);

    var note = fitted !== baseIndex
      ? (DATA.fit === 1
          ? 'This model runs large, so we have taken half a size off your measurement.'
          : 'This model runs small, so we have added half a size to your measurement.')
      : 'This model is true to size, so no adjustment was needed.';

    host.className = 'result' + (isThisPair ? '' : ' is-warn');
    host.innerHTML =
      '<p class="result__head">Your size is ' + UNIT + ' ' + s.eu + '</p>' +
      '<p class="result__sub">US ' + s.us + ' · UK ' + s.uk + ' · cut for a ' +
        Number(s.cm).toFixed(1) + ' cm foot. ' + note + '</p>' +
      (isThisPair
        ? '<p class="result__sub"><b>This pair is ' + UNIT + ' ' + s.eu + '.</b> It is your size.</p>'
        : '<p class="result__sub"><b>This pair is ' + UNIT + ' ' + selectedSize + '</b>, so it is not your size. ' +
          'Every pair is one size only.</p>' +
          '<a class="result__btn" href="' + shopUrlForSize(s.eu) + '">See ' + UNIT + ' ' + s.eu + ' pairs</a>');
  }

  var footGo = $('#footGo');
  if (footGo) {
    var runFoot = function () {
      var field = $('#footCm');
      var raw = parseFloat((field.value || '').replace(',', '.'));
      if (!raw || raw < 15 || raw > 40) {
        var host = $('#footResult');
        host.className = 'result is-warn';
        host.innerHTML = '<p class="result__head">Enter a length in centimetres</p>' +
          '<p class="result__sub">Adult feet usually measure between 22 and 31 cm.</p>';
        return;
      }
      recommend(indexForFoot(raw), '#footResult');
    };
    footGo.addEventListener('click', runFoot);
    $('#footCm').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); runFoot(); }
    });
  }

  var convGo = $('#convGo');
  if (convGo) {
    var sysSel = $('#convSystem');
    var valSel = $('#convSize');
    var fillValues = function () {
      var key = sysSel.value;
      valSel.innerHTML = chart.map(function (row, i) {
        return '<option value="' + i + '">' + key.toUpperCase() + ' ' + row[key] + '</option>';
      }).join('');
      valSel.value = Math.floor(chart.length / 2);
    };
    sysSel.addEventListener('change', fillValues);
    fillValues();
    convGo.addEventListener('click', function () {
      recommend(parseInt(valSel.value, 10), '#convResult');
    });
  }

  if (chartBody && chart.length) {
    chartBody.innerHTML = chart.map(function (row) {
      var here = String(row.eu) === String(selectedSize);
      return '<tr' + (here ? ' class="is-this"' : '') + '><td>' + row.eu + '</td><td>' + row.us +
        '</td><td>' + row.uk + '</td><td>' + Number(row.cm).toFixed(1) + '</td><td>' +
        (here ? 'This pair' : '') + '</td></tr>';
    }).join('');
  }

  var finder = $('#finder');
  var guideBtn = $('#sizeGuideBtn');
  if (guideBtn && finder) {
    guideBtn.addEventListener('click', function () {
      var open = finder.classList.toggle('is-open');
      guideBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) finder.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  $$('.ftab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var name = tab.dataset.pane;
      $$('.ftab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      $$('.fpane').forEach(function (pane) { pane.classList.toggle('is-active', pane.dataset.pane === name); });
    });
  });

  /* --------------------------------------------------------- add to cart */
  var form = $('#rekixBuyForm');
  var addBtn = $('#addBtn');

  function addToCart(afterEl) {
    // With one fixed size this should never fire, but a product whose size option is empty
    // would otherwise POST a null variant and 422.
    if (sizePos && selectedSize == null) {
      msg('This pair has no size set. Please contact us.', 'warn');
      return;
    }

    var id = ($('#rekixVariantId') || {}).value;
    if (!id) { msg('That combination is not available.', 'warn'); return; }

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.disabled = true; }

    fetch((window.REKIX && window.REKIX.routes ? window.REKIX.routes.cart : '/cart') + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {                       // Shopify returns {status, message, description} on error
          msg(res.description || res.message || 'Could not add that to the cart.', 'warn');
          return;
        }
        msg('');

        // The item is in the cart from here on. Anything that fails below is a DISPLAY problem, so
        // it must not be reported as a failed add -- an earlier single catch() around both stages
        // showed "Could not reach the cart" for a purchase that had actually succeeded, which is the
        // worst possible thing to tell a shopper. Fall through to the cart page instead.
        var cartUrl = (window.REKIX && window.REKIX.routes ? window.REKIX.routes.cart : '/cart');
        try {
          if (drawer && typeof drawer.renderContents === 'function') {
            // Clear the stale empty-cart flag BEFORE re-rendering.
            //
            // The drawer is rendered server-side as
            //   <cart-drawer class="drawer{% if cart == empty %} is-empty{% endif %}">
            // and Dawn's renderContents() only removes `is-empty` from `.drawer__inner`
            // -- an element that never carries it. getSectionsToRender() replaces the
            // innerHTML of #CartDrawer, which is INSIDE <cart-drawer>, so the class on
            // the wrapper survives. `.is-empty .cart__contents { display:none }`
            // (component-cart.css) then hides the whole line-item form while the
            // re-rendered footer and total show normally: a drawer with a correct
            // total above an empty white panel.
            //
            // Only bites on the first add of a session, because after that the page
            // reloads with a non-empty cart and the class is never printed.
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);         // re-renders AND opens
          } else {
            window.location.href = cartUrl;     // no drawer (e.g. cart-drawer.js still deferring)
          }
        } catch (e) {
          window.location.href = cartUrl;
        }
      })
      .catch(function () {
        // Only a genuine network/parse failure reaches here -- the add did NOT happen.
        msg('Could not reach the cart. Please try again.', 'warn');
      })
      .finally(function () {
        if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.disabled = false; }
      });
  }

  /* ----------------------------------------------------------- buy now
     Add the pinned variant, then go straight to checkout. Deliberately NOT a raw
     /cart/checkout link: that would check out whatever is already in the cart and
     silently skip this pair. Adding first also keeps the two buttons consistent --
     Buy now is Add to cart plus a redirect. */
  var buyNowBtn = $('#buyNowBtn');

  function buyNow() {
    if (sizePos && selectedSize == null) {
      msg('This pair has no size set. Please contact us.', 'warn');
      return;
    }
    var id = ($('#rekixVariantId') || {}).value;
    if (!id) { msg('That combination is not available.', 'warn'); return; }

    if (buyNowBtn) { buyNowBtn.setAttribute('aria-busy', 'true'); buyNowBtn.disabled = true; }

    fetch((window.REKIX && window.REKIX.routes ? window.REKIX.routes.cart : '/cart') + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        msg((err && err.description) || 'Could not start checkout. Please try again.', 'warn');
        if (buyNowBtn) { buyNowBtn.removeAttribute('aria-busy'); buyNowBtn.disabled = false; }
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      // Intercept only when we can do better than a full page post.
      if (!window.fetch) return;
      e.preventDefault();
      // submitter tells the two buttons apart; older browsers fall back to add-to-cart.
      var who = e.submitter || document.activeElement;
      if (who && who.id === 'buyNowBtn') buyNow();
      else addToCart();
    });
  }

  if (buyNowBtn) {
    // Safari <15.4 has no e.submitter; a direct click handler keeps Buy now correct there.
    buyNowBtn.addEventListener('click', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      buyNow();
    });
  }

  /* --------------------------------------------------------- lightbox
     Click the main image to open it full size; swipe, arrows, dots or the
     keyboard to move between shots. Transform-based rather than scroll-snap
     so a drag can follow the finger and snap back when it does not pass the
     threshold -- scroll-snap gives no way to cancel a half swipe. */
  (function lightbox() {
    var dlg = $('#pLight');
    if (!dlg) return;

    var track  = $('#pLightTrack');
    var stage  = $('#pLightStage');
    var slides = $$('.plight__slide', dlg);
    var dots   = $$('.plight__dot', dlg);
    var countEl = $('#pLightCount');
    var prevBtn = $('#pLightPrev');
    var nextBtn = $('#pLightNext');
    var n = slides.length;
    if (!track || !n) return;

    var i = 0, lastFocus = null;

    function render(animate) {
      track.classList.toggle('is-dragging', !animate);
      track.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)';
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (countEl) countEl.textContent = (i + 1) + ' / ' + n;
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === n - 1;
    }
    function go(k, animate) {
      i = Math.max(0, Math.min(n - 1, k));
      render(animate !== false);
    }

    function open(start) {
      lastFocus = document.activeElement;
      dlg.hidden = false;
      document.body.classList.add('has-modal');
      go(start || 0, false);
      // force a frame so the initial position is not animated from 0
      void track.offsetWidth;
      track.classList.remove('is-dragging');
      var x = dlg.querySelector('[data-plight-close]');
      if (x && x.focus) x.focus();
    }
    function close() {
      dlg.hidden = true;
      document.body.classList.remove('has-modal');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* Open from the main gallery image, at whichever shot is showing.
       The slides are all position:absolute in the same box and differ only by
       opacity, so a click lands on whichever is LAST in DOM order, not the one
       being looked at -- every click was opening the final image. Resolve the
       index from .is-active at click time; the per-image index is only a
       fallback for the case where nothing is marked active. */
    var galSlides = $$('.pgal__slides img');
    galSlides.forEach(function (img, k) {
      img.addEventListener('click', function () {
        var active = galSlides.indexOf($('.pgal__slides img.is-active'));
        open(active > -1 ? active : k);
      });
    });

    $$('[data-plight-close]', dlg).forEach(function (el) {
      el.addEventListener('click', close);
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(i - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });

    document.addEventListener('keydown', function (e) {
      if (dlg.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(i - 1);
      else if (e.key === 'ArrowRight') go(i + 1);
    });

    /* ------------------------------------------------------------ swipe */
    var startX = 0, startY = 0, dx = 0, dragging = false, decided = false, horizontal = false;

    function point(e) {
      var t = e.touches && e.touches[0] ? e.touches[0] : e;
      return { x: t.clientX, y: t.clientY };
    }

    stage.addEventListener('touchstart', function (e) {
      if (n < 2) return;
      var pt = point(e);
      startX = pt.x; startY = pt.y; dx = 0;
      dragging = true; decided = false; horizontal = false;
      track.classList.add('is-dragging');
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var pt = point(e);
      var mx = pt.x - startX, my = pt.y - startY;

      // Decide once whether this gesture is a swipe or a page scroll. Without the
      // lock, a mostly-vertical drag would still nudge the track sideways.
      if (!decided && (Math.abs(mx) > 8 || Math.abs(my) > 8)) {
        decided = true;
        horizontal = Math.abs(mx) > Math.abs(my);
        if (!horizontal) { dragging = false; track.classList.remove('is-dragging'); render(true); return; }
      }
      if (!horizontal) return;

      dx = mx;
      // resist at the ends so the first/last shot feels like a wall, not a bug
      if ((i === 0 && dx > 0) || (i === n - 1 && dx < 0)) dx *= 0.35;
      track.style.transform = 'translate3d(calc(' + (-i * 100) + '% + ' + dx + 'px),0,0)';
    }, { passive: true });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      var threshold = Math.min(90, stage.clientWidth * 0.18);
      if (dx <= -threshold) go(i + 1);
      else if (dx >= threshold) go(i - 1);
      else render(true);
      dx = 0;
    }
    stage.addEventListener('touchend', endDrag);
    stage.addEventListener('touchcancel', endDrag);

    render(false);
  })();

  /* ------------------------------------------------------- sticky buy bar */
  (function stickyBar() {
    var bar = document.getElementById('stickybuy');
    if (!bar || !addBtn) return;

    document.body.classList.add('has-stickybuy');

    var sbBtn = $('#sbBtn');
    if (sbBtn) sbBtn.addEventListener('click', function () { addToCart(); });

    function update() {
      var r = addBtn.getBoundingClientRect();
      var footer = document.querySelector('.footer');
      var nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight + 40;
      var show = r.bottom < 0 && !nearFooter;
      bar.classList.toggle('is-up', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

})();

/* Condition guide (2026-11-02): the (i) on the grade pill. CSS opens it on hover/focus where there is
   hover; this makes it work by tap too, and closes it on the X, Escape or a tap anywhere else. */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-gradeinfo]');
  if (!wrap) return;
  var btn = wrap.querySelector('[data-gradeinfo-btn]');
  var close = wrap.querySelector('[data-gradeinfo-close]');
  function set(open) {
    wrap.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (btn) btn.addEventListener('click', function (e) {
    e.preventDefault();
    set(!wrap.classList.contains('is-open'));
  });
  if (close) close.addEventListener('click', function (e) {
    e.preventDefault();
    set(false);
    // drop focus too, or :focus-within keeps it open on a desktop
    if (document.activeElement && wrap.contains(document.activeElement)) document.activeElement.blur();
  });
  document.addEventListener('click', function (e) {
    if (wrap.classList.contains('is-open') && !wrap.contains(e.target)) set(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && (wrap.classList.contains('is-open') || wrap.contains(document.activeElement))) {
      set(false);
      if (document.activeElement && wrap.contains(document.activeElement)) document.activeElement.blur();
    }
  });
})();
